<div class="item" (click)="!notification.isRead && markedAsRead(notification.id)">
  <div class="error" *ngIf="notification.severity === 'error'">
    <i class="icon-content-error"></i>
  </div>
  <div class="warning" *ngIf="notification.severity === 'warn'">
    <i class="icon-content-warning"></i>
  </div>
  <div class="info" *ngIf="notification.severity === 'info'">
    <i class="icon-content-info"></i>
  </div>
  <div class="success" *ngIf="notification.severity === 'success'">
    <i class="icon-content-success"></i>
  </div>
  <i class="icon-content-unread unread-icon" [class.hidden]="notification.isRead"></i>
  <div class="item-content">
    <span class="date">{{ notification?.date | date: 'dd/MM/YYYY - h:mm a' }}</span>
    <span class="summary">{{ notification?.summary }}</span>
    <button *ngIf="notification.type === 'MESSAGE'" avanoButton>
      <i class="icon-content-download"></i>
      {{ translationKeys.avano.notifications.btn.showDetails | translate }}
    </button>
    <button *ngIf="notification.type === 'DOWNLOAD'" (click)="download(notification.reportDto.id, notification.reportDto.filename)" avanoButton>
      <i class="icon-content-download"></i>
      {{ translationKeys.avano.notifications.btn.download | translate }}
    </button>
  </div>
  <div class="item-actions">
    <button class="avano-icon-btn" (click)="delete(notification.id); $event.stopPropagation()">
      <i class="icon-content-trash"></i>
    </button>
  </div>
</div>
